import { render } from "./SuccessComponent.vue?vue&type=template&id=60b02d29"
import script from "./SuccessComponent.vue?vue&type=script&lang=js"
export * from "./SuccessComponent.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sweaton/WebstormProjects/paygateway/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__